export const CASL_CREATE = 'create';
export const CASL_UPDATE = 'update';
export const CASL_DELETE = 'delete';
export const CASL_READ = 'read';
export const CASL_UPDATE_STATUS = 'update-status';
export const CASL_APPROVE = 'approve';
